import axios from "axios";
import { useEffect, useState } from "react";
import { getSecureUser } from "../utils/secureStorage";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Box
} from "@mui/material";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaBan
} from "react-icons/fa";

function ViewEnrolledCourse() {
  const [viewEnrollCourse, setViewEnrollCourse] = useState([]);

  useEffect(() => {
    const userData = getSecureUser();
    const url = `_AP${process.env.REACTP_API}/enrollment/view_enrol/${userData.id}`;
    axios.get(url, { withCredentials: true }).then((res) => {
      setViewEnrollCourse(res.data.data);
    });
  }, []);

  const handleCancelEnroll = (enrollId) => {
    const url = `${process.env.REACT_APP_API}/enrollment/cancel/${enrollId}`;
    axios
      .patch(url, {}, { withCredentials: true })
      .then(() => {
        setViewEnrollCourse((prev) =>
          prev.filter((course) => course.enrolment_id !== enrollId)
        );
      })
      .catch((error) => {
        console.error("Cancel failed:", error);
      });
  };

  return (
    <Box p={3} >
      <div className="user-details-wrapper">
        <Typography variant="h4" gutterBottom align="center">
          Enrolled Courses
        </Typography>
        {viewEnrollCourse.length > 0 ? (
          <TableContainer
            component={Paper}
            sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1976d2" }}>
                  {[
                    "S.No",
                    "Course Name",
                    "Course Status",
                    "Completion Date",
                    "Running Date",
                    "Enrollment Status",
                    "Paid Status",
                    "Fee",
                    "Cancel"
                  ].map((title, i) => (
                    <TableCell
                      key={i}
                      sx={{
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "0.7rem",
                        backgroundColor: "#1050A2",
                        textAlign: "center"
                      }}
                    >
                      {title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {viewEnrollCourse.map((data, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:nth-of-type(odd)": {
                        backgroundColor: "#f9f9f9"
                      },
                      "&:hover": {
                        backgroundColor: "#facb1524"
                      }
                    }}
                  >
                    <TableCell sx={{ textAlign: "center" }}>{index + 1}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{data.name}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{data.course_status}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{data.completiondate || "—"}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{data.runningdate || "—"}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{data.enrolment_status || "—"}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {data.course_paid_status ? (
                        <Tooltip title="Paid">
                          <FaCheckCircle color="green" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Not Paid">
                          <FaTimesCircle color="red" />
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      {data.fee}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Tooltip title="Cancel Enrollment">
                        <IconButton
                          color="error"
                          onClick={() => handleCancelEnroll(data.enrolment_id)}
                        >
                          <FaBan />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography
            align="center"
            mt={10}
            fontSize="1.8rem"
            fontWeight={500}
            color="text.secondary"
          >
            No enrolled courses to display.
          </Typography>
        )}
      </div>
    </Box>
  );
}

export default ViewEnrolledCourse;
